import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import { EditBlockForm } from "./EditBlockForm";
import type { PlatformBlock } from "../types";

interface EditBlockDialogProps {
  open: boolean;
  onClose: () => void;
  block: PlatformBlock;
  onCompleted: (block: PlatformBlock) => void;
  platformId?: string;
  queries?: Record<string, any>;
  activeTab?: "SETTINGS" | "VISIBILITY";
}

/**
 * Диалог редактирования существующего блока
 */
export const EditBlockDialog: React.FC<EditBlockDialogProps> = ({
  open,
  onClose,
  block,
  onCompleted,
  platformId,
  queries,
  activeTab,
}) => {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm" scroll="body">
      <EditBlockForm
        title={t("platformBlocks.dialog.editTitle")}
        onClose={onClose}
        onSubmit={onCompleted}
        onCancel={onClose}
        initialValues={block}
        platformId={platformId}
        queries={queries}
        activeTab={activeTab}
        mode="edit"
        submitText={t("platformBlocks.dialog.save")}
      />
    </Dialog>
  );
};
